// extracted by mini-css-extract-plugin
module.exports =  {"verticalCompensation":"2px","unit":"var(--ring-unit)","downloadLink":"ArtifactsDownloadAll__downloadLink--NI"};